import StaticLayout from 'common/Layout/StaticLayout';
import { Text } from 'common/styles';
import { __t } from 'common/i18n';
import StaticText from 'common/StaticText';
import Head from 'next/head';

export default function Rules() {
  return <>
    <Head>
      <title>{__t('siteName')} | {__t('static.rules.title')}</title>
      <link rel="canonical" href='https://filmnet.ir/rules' />
    </Head>
    <StaticLayout cover="/static/images/static_pages/rules_cover_img.jpg" title={__t('static.rules.title')}>
      <Text variant="h2" mb={1}>{__t('static.rules.privay.title')}</Text>
      <StaticText>{__t('static.rules.privay.desc')}</StaticText>

      <Text variant="h2" mb={1} mt={6}>{__t('static.rules.services.title')}</Text>
      <StaticText>{__t('static.rules.services.desc')}</StaticText>

      <Text variant="h2" mb={1} mt={6}>{__t('static.rules.account.title')}</Text>
      <StaticText>{__t('static.rules.account.desc')}</StaticText>
    </StaticLayout>
  </>;
}
